<button *ngIf="!view.hideIfDisabled || !view.disabled" class="dropdown-item align-middle pr-0" [class.disabled]="view.disabled" type="button" (click)="onClick($event)">
  <div title="{{view.title}}" class="row w-100 py-2">
    <co-image *ngIf="view.icon" width="24" height="24" [isVault]="view.isVaultIcon" type="svg" [imageSet]="view.iconImageSet" class="col-auto px-2 item-icon" [key]="view.icon"></co-image>
    <div class="col item-title ellipsis"> {{view.title}}</div>
  </div>
</button>
